import React from "react";

const Pause = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill" fill={fill} d="M6 2h6v32H6zM24 2h6v32h-6z" />
    </svg>
);

export default Pause;
